import { IPhoneticSystem } from '../types/IPhoneticSystem';
import {
    jyutpingFinals, jyutpingInitials, PhoneticType,
} from '../constants';
import { ISyllable } from '../types/ISyllable';
import convertRomanization from '../helpers/convertRomanization';

const innerRegex = `(${jyutpingInitials.join('|')})(${jyutpingFinals.join('|')})([1-6])`;
const jyutpingRegex = new RegExp(`^${innerRegex}$`, 'i');
const jyutpingBoundariesRegex = new RegExp(`(${innerRegex})(?=${innerRegex})`, 'gi');

class JyutpingSystem implements IPhoneticSystem {
    name = PhoneticType.Jyutping;

    decomposeSyllable(syllables: string): ISyllable {
        const allSylls = syllables.split(';');
        const syllable = allSylls[0];
        const matchJyutping = jyutpingRegex.exec(syllable);

        if (matchJyutping) {
            return {
                valid: true,
                type: PhoneticType.Jyutping,
                onset: matchJyutping[1],
                rhyme: matchJyutping[2],
                tone: Number.parseInt(matchJyutping[3], 10),
                syllable,
                notone: matchJyutping[1] + matchJyutping[2],
                ambiguous: false,
            };
        }
        return {
            valid: false,
            onset: '',
            rhyme: syllable,
            tone: 0,
            syllable,
            notone: syllable,
            type: PhoneticType.Invalid,
            ambiguous: allSylls.length > 1,
        };
    }

    markSyllableBoundaries(message: string): string {
        return message.replace(jyutpingBoundariesRegex, '$1-');
    }

    convertTo(message: string, fromSystem: PhoneticType): string {
        return convertRomanization(message, this.name, fromSystem);
    }
}

export default JyutpingSystem;
